import { api, datesToISO } from "@";

// Function to get general report data
export const getGeneralReport = async (params) => {
  try {
    const { data } = await api.post(`/api/adminDashboard/statistics`, {
      fromDate: datesToISO(params.fromDate),
      toDate: datesToISO(params.toDate),
    });
    return data;
  } catch (error) {
    return [];
  }
};

// Function to get statistics data
export const getStatisticData = async () => {
  try {
    const [numbersRes, calculationsRes] = await Promise.all([
      api.get("/api/AdminDashboard"),
      api.get("/api/AdminDashboard/calculations"),
    ]);
    return {
      numbers: numbersRes?.data,
      calculations: calculationsRes?.data,
      latestDonations: calculationsRes?.data?.recentOrders || [],
      totalDonationsChart: calculationsRes?.data?.totalDonationsInYears || [],
    };
  } catch (error) {
    return {
      numbers: null,
      calculations: null,
      latestDonations: [],
      totalDonationsChart: [],
    };
  }
};

// Function to get the orders data
export const getOrders = async (time) => {
  try {
    const { data } = await api.post(`/api/AdminDashboard/orders`, {
      searchTimeInterval: parseInt(time),
    });
    return data?.ordersAmountInTimeIntervals;
  } catch (error) {
    return [];
  }
};
